import logo from './images/logo.jpg';
import increment from './images/increment-decrement.jpg';
import './Common.css';



function Header() {
    return (
      <header className='header'>
        <div className='container'>
            <div className='row align-items-center'>
                <div className='col-md-6'>
                    <img src={logo} className="logo" alt="logo" />
                </div>
                <div className='col-md-6'>
                    <div className='Search-Flex'>
                        <div className='Header-Search'>
                            <form>
                                <input type="text" placeholder='Search for a company or LEI code' name="name" />
                                <button><i class="fas fa-search"></i> Search</button>
                            </form>
                        </div>
                        <div className='Gig-Guideline'>  
                            <img src={increment} className="logo" alt="logo" />                  
                            <i class="fas fa-globe"></i>
                        </div>
                    </div>                    
                </div>
            </div>
        </div> 
      </header>          
    );
  }
  
  export default Header;